import store from '@/store'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    meta: {
      requiresAuth: false,
      title:"Login"
    }
  },
  {
    path: '/home',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('SystemAuthentication').then(response => {
        store.dispatch('user_system_logged')
        if (response) {
          next();
        }
      }).catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("_system");
        localStorage.removeItem("_system_token");
        return next({ name: "system" })
      });
    },
    children: [{
      path: '/items',
      name: 'item',
      component: () => import(/* webpackChunkName: "items" */ '../views/ItempriceView.vue'),
      meta: {
        requiresAuth: true,
        title:"Item"
      }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import(/* webpackChunkName: "order" */ '../views/OrdersView.vue'),
      meta: {
        requiresAuth: true,
        title:"Order"
      }
    },
    {
      path: '/statement-of-accounts',
      name: 'soa',
      component: () => import(/* webpackChunkName: "order" */ '../views/StatementOfAccountsView.vue'),
      meta: {
        requiresAuth: true,
        title:"Order"
      }
    },
    {
      path: '/my-profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "order" */ '../views/MyProfileView.vue'),
      meta: {
        requiresAuth: true,
        title:"Order"
      }
    }
    ],
    meta: {
      requiresAuth: true,
       title: "Home",
    }
  },
  {
    path: '/system',
    name: 'system',
    component: () => import(/* webpackChunkName: "system" */ '../views/SystemselectionView.vue'),
    beforeEnter: (to, from, next) => {
      localStorage.removeItem("_system")
      localStorage.removeItem("_system_token")
      store.dispatch('authentication').then(response => {
        store.dispatch('user_logged')
        if (response) {
          next();
        }
      }).catch(() => {
        localStorage.removeItem("token");
        return next({ name: "login" })
      });
    },
    meta: {
      requiresAuth: true,
      title:"Best Tools Group"
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem("token")) {
    next();
  } else if (!to.meta.requiresAuth && localStorage.getItem("token")) {
    next("/home");
  } else {
    store.commit('DTPAYLOAD',{})
    next();
  }
  document.title = localStorage.getItem('_system') ? JSON.parse(localStorage.getItem('_system'))?.name + " - " + to.meta.title : to.meta.title
});

export default router;
